export type TextBlockModalContext = {
  fieldName: string;
  fieldLabel: string;
  contextRef: string;
  initialValue: string;
  onSave: (value: string) => void;
  onAfterClose?: () => void;
};

let currentContext: TextBlockModalContext | null = null;

export const TEXT_BLOCK_MODAL_OPEN_EVENT = 'textBlockModal:open';
export const TEXT_BLOCK_MODAL_CLOSE_EVENT = 'textBlockModal:close';

export function setTextBlockModalContext(ctx: TextBlockModalContext) {
  currentContext = ctx;
}

export function getTextBlockModalContext() {
  return currentContext;
}

export function openTextBlockModal() {
  document.dispatchEvent(new CustomEvent(TEXT_BLOCK_MODAL_OPEN_EVENT));
}

export function closeTextBlockModal() {
  document.dispatchEvent(new CustomEvent(TEXT_BLOCK_MODAL_CLOSE_EVENT));
}


